export default __webpack_public_path__ + "static/media/pending-orange-clock.5bf20663.svg";